import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Intervention from "./sections/Intervention";
import Questions from "./sections/Questions";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <Contact />
      <Intervention />
      <Questions />
      <Footer />
    </div>;
}